module.exports = __webpack_public_path__ + "img/1497475361.b6f8f351.jpg";